import { render, staticRenderFns } from "./PromoCodeForm.vue?vue&type=template&id=2c6b4c2a&"
import script from "./PromoCodeForm.vue?vue&type=script&lang=js&"
export * from "./PromoCodeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports